import React from 'react';
import { Alert, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { BieMoney } from '../bie/BieValue';

type Props = { data?: any };

class SimulationExecutivePanel extends React.PureComponent<Props> {
  metric(label: string, value: any, tone?: string) {
    return (
      <Grid size={{ xs: 6, md: 3 }} key={label}>
        <Card elevation={1}><CardContent>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
          <Typography variant="h6" sx={{ fontWeight: 800, color: tone ? `${tone}.main` : 'text.primary' }}><BieMoney value={value} /></Typography>
        </CardContent></Card>
      </Grid>
    );
  }
  render() {
    const d = this.props.data || {};
    const checks = d.checks || {};
    return (
      <Stack spacing={2}>
        <Grid container spacing={2}>
          {this.metric('Projected Revenue', d.revenue)}
          {this.metric('Projected Cost', d.cost)}
          {this.metric('Gross Margin', d.margin, Number(d.margin || 0) >= 0 ? 'success' : 'error')}
          {this.metric('Partial Result', d.partialresult, Number(d.partialresult || 0) >= 0 ? 'success' : 'error')}
          {this.metric('Economic Capacity', d.economiccapacity, 'info')}
          {this.metric('Budget Consumption', d.budgetconsumption)}
          {this.metric('Available Budget', d.availablebudget, 'success')}
          {this.metric('Stress Rating', d.stressvalue || 0, d.stresscode === 'HIGH' ? 'error' : 'success')}
        </Grid>
        <Alert severity={checks.ready ? 'success' : 'warning'}>{checks.message || 'Review assumptions, formula validation, constraints and scenario readiness before submitting for approval.'}</Alert>
      </Stack>
    );
  }
}
export default SimulationExecutivePanel;
